module.exports = __webpack_public_path__ + "img/ddhy.eac77c13.png";